import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg, fmt, toIso } from "./crmUtil";

// Follow-up tasks with due dates and an optional in-app reminder time.
export default function TasksCard({ entity, id }) {
  const [tasks, setTasks] = useState([]);
  const [form, setForm] = useState({ title: "", due: "", remind: "" });
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/crm/${entity}/${id}/tasks`).then((r) => setTasks(r.data)).catch((e) => setErr(errMsg(e))), [entity, id]);
  useEffect(() => { load(); }, [load]);
  const add = async (e) => {
    e.preventDefault(); setErr("");
    try {
      await api.post(`/crm/${entity}/${id}/tasks`, { title: form.title.trim(), due_at: toIso(form.due), ...(form.remind && { remind_at: toIso(form.remind) }) });
      setForm({ title: "", due: "", remind: "" }); load();
    } catch (x) { setErr(errMsg(x)); }
  };
  const done = async (t) => { try { await api.patch(`/crm/tasks/${t.id}`, { status: "done" }); load(); } catch (x) { setErr(errMsg(x)); } };
  const now = new Date().toISOString();
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4 space-y-3" data-testid="tasks-card" aria-labelledby="tasks-title">
      <h3 id="tasks-title" className="font-display font-semibold">Follow-up tasks</h3>
      {err && <p role="alert" className="text-sm text-red-700" data-testid="tasks-error">{err}</p>}
      {tasks.length === 0 ? <p className="text-xs font-mono text-erf-dark/60" data-testid="tasks-empty">No follow-ups yet.</p> : (
        <ul className="divide-y divide-erf-borderCream/60">
          {tasks.map((t) => (
            <li key={t.id} className="py-2 flex flex-wrap items-center justify-between gap-2" data-testid={`task-${t.id}`}>
              <div>
                <p className={`text-sm font-nav ${t.status === "done" ? "line-through text-erf-dark/50" : ""}`}>{t.title}</p>
                <p className="text-xs text-erf-dark/60">Due {fmt(t.due_at)}{t.status === "open" && t.due_at < now ? " · Overdue" : ""}{t.remind_at ? ` · Reminder ${fmt(t.remind_at)}${t.reminder_sent_at ? " (sent)" : ""}` : ""}</p>
              </div>
              {t.status === "open" && <button type="button" onClick={() => done(t)} className={`${BTN} border border-erf-borderCream`} data-testid={`task-done-${t.id}`}>Mark done</button>}
            </li>
          ))}
        </ul>
      )}
      <form onSubmit={add} className="grid gap-2 sm:grid-cols-[1fr_12rem_12rem_auto] sm:items-end">
        <label htmlFor="task-title" className="text-sm">Task<input id="task-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className={INPUT} data-testid="task-title" /></label>
        <label htmlFor="task-due" className="text-sm">Due<input id="task-due" type="datetime-local" value={form.due} onChange={(e) => setForm({ ...form, due: e.target.value })} className={INPUT} data-testid="task-due" /></label>
        <label htmlFor="task-remind" className="text-sm">Remind me (in-app)<input id="task-remind" type="datetime-local" value={form.remind} onChange={(e) => setForm({ ...form, remind: e.target.value })} className={INPUT} data-testid="task-remind" /></label>
        <button type="submit" disabled={form.title.trim().length < 2 || !form.due} className={`${BTN} bg-erf-dark text-white`} data-testid="task-add">Add task</button>
      </form>
    </section>
  );
}
